import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  constructor(private RT: Router) {}
  canActivate() {
    if (
      !localStorage.getItem('token') ||
      !localStorage.getItem('email_verified')
    ) {
      return true;
    } else {
      this.RT.navigate([
        localStorage.getItem('company') ? `/wallet` : `/account-verification`,
      ]);
      return false;
    }
  }
}
